function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M123.3,109.3H26.8c-4,0-7.2-3.2-7.2-7.2V44.9c0-4,3.2-7.2,7.2-7.2h96.5c4,0,7.2,3.2,7.2,7.2v57.2 C130.5,106.1,127.3,109.3,123.3,109.3z M26.8,42.6c-1.3,0-2.3,1-2.3,2.3v57.2c0,1.3,1,2.3,2.3,2.3h96.5c1.3,0,2.3-1,2.3-2.3V44.9 c0-1.3-1-2.3-2.3-2.3H26.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M41.2,125.4c-1.4,0-2.4-1.1-2.4-2.4V26.8c0-1.4,1.1-2.4,2.4-2.4c1.4,0,2.4,1.1,2.4,2.4V123 C43.7,124.3,42.6,125.4,41.2,125.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M104.9,125.4c-1.4,0-2.4-1.1-2.4-2.4V26.8c0-1.4,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4V123 C107.3,124.3,106.2,125.4,104.9,125.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M57.8,62.4h-4.5c-0.5,0-0.9-0.4-0.9-0.9V57c0-0.5,0.4-0.9,0.9-0.9h4.5c0.5,0,0.9,0.4,0.9,0.9v4.5 C58.7,62,58.3,62.4,57.8,62.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M75.3,62.4h-4.5c-0.5,0-0.9-0.4-0.9-0.9V57c0-0.5,0.4-0.9,0.9-0.9h4.5c0.5,0,0.9,0.4,0.9,0.9v4.5 C76.2,62,75.8,62.4,75.3,62.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M92.8,62.4h-4.5c-0.5,0-0.9-0.4-0.9-0.9V57c0-0.5,0.4-0.9,0.9-0.9h4.5c0.5,0,0.9,0.4,0.9,0.9v4.5 C93.6,62,93.3,62.4,92.8,62.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M57.8,92.9h-4.5c-0.5,0-0.9-0.4-0.9-0.9v-4.5c0-0.5,0.4-0.9,0.9-0.9h4.5c0.5,0,0.9,0.4,0.9,0.9V92 C58.7,92.5,58.3,92.9,57.8,92.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M75.3,92.9h-4.5c-0.5,0-0.9-0.4-0.9-0.9v-4.5c0-0.5,0.4-0.9,0.9-0.9h4.5c0.5,0,0.9,0.4,0.9,0.9V92 C76.2,92.5,75.8,92.9,75.3,92.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M92.8,92.9h-4.5c-0.5,0-0.9-0.4-0.9-0.9v-4.5c0-0.5,0.4-0.9,0.9-0.9h4.5c0.5,0,0.9,0.4,0.9,0.9V92 C93.6,92.5,93.3,92.9,92.8,92.9z"
}));

var SvgMonitoringSetupIcon = function SvgMonitoringSetupIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMonitoringSetupIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/monitoring-setup-icon.c3492589.svg";
export { ForwardRef as ReactComponent };